import Form from 'components/landing/Form';
import Button from '@mui/material/Button';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';

export default function ContactSection() {
    return (
        <section id="contact" className="pb-20 relative block" style={{ backgroundColor: '#304c79' }}>
            <div className="container max-w-7xl mx-auto px-4 pt-12 lg:pt-24">
                <Form />
                <div className="w-full text-center mt-12">
                    <h3 className="text-3xl font-semibold text-white">Want to Donate?</h3>
                    <p className="text-lg leading-relaxed mt-4 mb-4 text-gray-300">
                        Follow this link to donate to our cause!
                    </p>
                    <Button
                        href="https://www.paypal.com/donate/?hosted_button_id=GQYSX34TALUHW"
                        variant="contained"
                        sx={{
                            backgroundColor: '#FFFFFF',
                            color: '#304c79',
                            fontWeight: 'bold',
                            '&:hover': { backgroundColor: '#e2e8f0' },
                        }}
                        endIcon={<VolunteerActivismIcon />}>
                        Donate Now!
                    </Button>
                </div>
            </div>
        </section>
    );
}
